var vars = require('./core');

module.exports = vars.createClass('Doughnut', ['getSegmentsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/doughnut.js